import { logo } from '../../components/ui/logo'
import { cn } from '../../lib/utils'

interface LoadingPageProps {
  className?: string
}

export function LoadingPage({ className = '' }: LoadingPageProps) {
  const LogoComponent = logo({
    className: 'h-50 w-50',
    loading: true,
  })
  return (
    <div className={cn(`flex flex-col items-center justify-center min-h-screen`, className)}>
      {/* Pulsing logo with scale animation */}
      <div
        className="mb-8"
        style={{
          animation: 'fade-in 1s ease-out, scale-pulse ease-in-out infinite 1s',
        }}
      >
        <LogoComponent />
      </div>

      <style>
        {`
          @keyframes fade-in {
            0% { opacity: 0; }
            100% { opacity: 1; }
          }

          @keyframes scale-pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
        `}
      </style>
    </div>
  )
}
